function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import PageBackButton from '../common/page/PageBackButton.react';
import PpcClientDetails from './PpcClientDetails.react';
import PpcClientLogo from './PpcClientLogo.react';
import PpcClientDelete from './PpcClientDelete.react';
var PpcClient = function PpcClient() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    app = _useParams.app,
    clientID = _useParams.clientID;
  var clients = useSelector(function (s) {
    return s.ppc.clients;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.clients,
      payload: {}
    });
  }, []);
  useEffect(function () {
    if (clients[clientID]) setState(clients[clientID]);
  }, [clients, clientID]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement(PageBackButton, null), state._id && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PpcClientDetails, {
    client: state
  }), /*#__PURE__*/React.createElement(PpcClientLogo, {
    client: state
  }), /*#__PURE__*/React.createElement(PpcClientDelete, {
    client: state
  })));
};
export default PpcClient;